// JOBE-0162.4: tiny debounce hook.
//
// Coalesces rapid `value` updates into a single trailing emission after
// `delayMs` of quiet. Cancels the pending timeout on every change (so a
// burst of keystrokes still resolves to exactly one update). Used by the
// organization search bar to keep keystroke-rate re-renders down on
// larger directories.

import { useEffect, useState } from 'react';

/**
 * @template T
 * @param {T} value
 * @param {number} [delayMs=150]
 * @returns {T}
 */
export function useDebouncedValue(value, delayMs = 150) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
